import React from 'react'
import Avatar from './commons/avatar'
import {
  Container,
  HeaderContent,
  ParagraphContent,
} from './commons/components'
import ActionButtons from './commons/action-buttons'
import PropTypes from 'prop-types'

export default function Generic({
  variant,
  displayName,
  recipient,
  onConfirm,
  onCancel,
  firstName = '',
  lastName = '',
  country = '',
}) {
  return (
    <Container>
      <Avatar />
      <HeaderContent
        variant={variant}
        recipient={recipient}
        displayName={displayName}
      />
      <ParagraphContent
        variant={variant}
        firstName={firstName}
        lastName={lastName}
        country={country}
      />
      <ActionButtons onConfirm={onConfirm} onCancel={onCancel} />
    </Container>
  )
}

Generic.propTypes = {
  recipient: PropTypes.string,
  displayName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  country: PropTypes.string,
  variant: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
